var tokens = require('./dist/index.common.js');
var meta = require('./dist/index.meta.js');
module.exports = {
  tokens: tokens,
  meta: meta
};